import { Row, Col } from "antd";

import { useState, useEffect, useRef } from "react";

import InformationCard from "./InformationCard";

export default function ShowCaseCardRow(options, props) {
  const [isMobile, setIsMobile] = useState(false);
  const [clickedCard, setClickedCard] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!isVisible && entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.1,
      }
    );

    const currentRef = ref.current;

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [isVisible]);

  useEffect(() => {
    setClickedCard([]);
    setIsVisible(false);
  }, [options]);

  useEffect(() => {
    const handleResize = () =>
      setIsMobile(window.innerHeight > window.innerWidth ? true : false);
    window.addEventListener("resize", handleResize);
    // Call handleResize right away so that isMobile is set correctly initially
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <Row
      justify="center"
      style={{
        paddingLeft: isMobile ? 0 : "5vw",
        paddingRight: isMobile ? 0 : "5vw",
      }}
    >
      {options.children.map((option, index) => {
        const firstItem = index === 0;

        return (
          <Col
            span={isMobile ? 20 : 8}
            style={{
              paddingLeft: isMobile ? 0 : "2%",
              paddingBottom: isMobile ? "5vh" : "10vh",
              paddingRight: isMobile ? 0 : "2%",
            }}
            key={option.title + index}
          >
            <InformationCard
              option={option}
              isVisible={isVisible}
              delay={0.25 * index}
              clicked={clickedCard.includes(index)}
              onClick={() => {
                if (clickedCard.includes(index)) {
                  setClickedCard(clickedCard.filter((card) => card !== index));
                } else {
                  setClickedCard([...clickedCard, index]);
                }
              }}
              isFirstItem={firstItem}
              refProp={ref}
              hovermode={props.hovermode}
            />
          </Col>
        );
      })}
    </Row>
  );
}
